import $ from 'jquery'

$(document).on('turbo:load', function () {
  if ($('#calendar').length) {
    $('#calendar').fullCalendar({
      locale: 'de',
      events: '/events.json',
      height: 'auto',
      timeFormat: 'HH:mm',
      eventClick: function (event) {
        if (event.id) {
          window.location.href = `/events/${event.id}`;
        }
      }
    })
  }
})

$(document).on('turbo:before-cache', function () {
  $('#calendar').fullCalendar('destroy');
  $('#calendar').html('');
});
